import interact from "../../services/interact";

/**
 * @example this should only be added once on <body> tag
 * @returns {boolean}
 */

export default (vue) => {
    // Interacted
    interact.event((o) => {
        if ("IntersectionObserver" in window ) {

            let observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.intersectionRatio > 0) {

                        let ul = document.createElement('ul');
                        ul.dataset.vi = "stats";
                        let ol = document.createElement('ul');
                        ol.dataset.vi = "bottom";
                        ol.insertAdjacentHTML('beforeend', '<li data-vi="views"><svg data-vi="eye" width="14" height="14" viewBox="0 0 24 24" width="12"><path fill="currentColor" d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/></svg><span>' + entry.target.dataset.views+ '</span></li>');
                        if ( entry.target.dataset.exclusive === 'true') {
                            ul.insertAdjacentHTML('beforeend', '<li data-vi="star">&#9733;</li>');
                            // ol.insertAdjacentHTML('beforeend', '<li data-vi="badge">Exclusive</li>');
                        }
                        ul.insertAdjacentHTML('beforeend', '<li data-vi="time">' + entry.target.dataset.duration+ '</li>');
                        if ( entry.target.dataset.hd === 'true') {
                            ul.insertAdjacentHTML('beforeend', '<li data-vi="hd">HD</li>');
                        }
                        if ( entry.target.dataset.vr === 'true') {
                            ul.insertAdjacentHTML('beforeend', '<li data-vi="vr">VR</li>');
                        }
                        entry.target.firstElementChild.appendChild(ul);
                        entry.target.firstElementChild.appendChild(ol);

                        observer.unobserve(entry.target);

                        let button = entry.target.querySelector('.video-item-remove');
                        if ( button ) {
                            button.addEventListener(('ontouchstart' in document.documentElement ? 'touchstart' : 'click'), () => {
                                if (!window.confirm(button.dataset.message)) {
                                    return;
                                }
                                fetch(button.dataset.action,
                                    {
                                        headers: {
                                            "Content-Type": "application/json",
                                            'X-Requested-With': 'XMLHttpRequest'
                                        },
                                        method: "POST",
                                        body: JSON.stringify({
                                            [vue.get('service.security.csrfToken.name')]: vue.get('service.security.csrfToken.value'),
                                            movie_id:  button.dataset.movieId,
                                            playlist_id: button.dataset.listId,
                                        })
                                    })
                                    .then((data) => {
                                        return data.json();
                                    })
                                    .then((data) => {
                                        if (data.success) {
                                            entry.target.remove();
                                        }
                                    })

                            });
                        }
                    }
                });
            });

            let items = document.querySelectorAll("[data-video-item]");

            items = Array.prototype.slice.call ( items );

            items.forEach((item) => {
                observer.observe(item);
            });
        }
    });
};